import React from 'react'
import CodeOrg from 'assets/images/code_org.svg'
import leftQuote from 'assets/images/quote-left.svg'

const Card3 = ({ background, invertedComma }) => {
  return (
    <div className="flex">
      <div>
        {invertedComma && <img src={leftQuote} className="mt-10 sm:ml-8" />}
      </div>

      <div
        className={`right ${
          background ? background : 'bg-white'
        } pl-[26px]  p-6 sm:w-[393px] relative sm:mt-0 mt-8 sm:rounded-[20px]`}
        // style="box-shadow: 0px 6px 10px #00000029; border-radius: 22px;"
      >
        {invertedComma ? (
          ''
        ) : (
          <p className="font-medium text-[18px] font-sans">
            "Efficient and very good customer <br /> service."
          </p>
        )}
        <p className="text-[#00173A] font-sans leading-relaxed pt-5">
          The Tomedes team was very <br /> responsive and quick to help us{' '}
          <br />
          address any issues related to <br /> timeline and quality of
          translation...
          <br />I would recommend the Tomedes <br /> team to any computer
          science <br /> curriculum providers.
        </p>

        <div className="pt-12">
          <img src={CodeOrg} alt="" />
          <p className="text-[18px] font-medium font-secondary pt-3">
            Jorge Castro
            {invertedComma ? (
              <>
                <span className="text-[18px] font-medium font-secondary">
                  ,
                </span>
                <a
                  href="https://www.trustpilot.com/reviews/61b11ffd2b49257fe29a48fa"
                  target="_blank"
                  className="ml-3 text-orange bold"
                >
                  Code.org
                </a>
              </>
            ) : (
              ''
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Card3
